import { SECTION } from "constants/SettingsConstants";
import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { setCurrentSection, setValidationState } from "reducers/main";
import { useGetLienValidationByIdQuery } from "services/lien-api";
import type { LienValidation, ValidationDataType } from "types/DataTypes";
import { useDispatch } from "utils/redux";

type LienContainerPropTypes = {
  header?: React.ReactNode;
  children: React.ReactNode;
  footer?: React.ReactNode;
};

const LienPageContainer = ({
  header,
  footer,
  children,
}: LienContainerPropTypes) => {
  const dispatch = useDispatch();
  const { lienId } = useParams<{ lienId?: string }>();

  const { data: lienValidation } = useGetLienValidationByIdQuery<{
    data: LienValidation;
  }>({ lienId: lienId || "" }, { skip: !lienId });

  useEffect(() => {
    dispatch(setCurrentSection(SECTION.LIENS));
  }, [dispatch]);

  useEffect(() => {
    if (lienValidation) {
      const extractedErrors: ValidationDataType[] =
        lienValidation.errors.filter(
          (error: ValidationDataType) => error.level === "ERROR",
        );

      const extractedWarnings: ValidationDataType[] =
        lienValidation.errors.filter(
          (warning: ValidationDataType) => warning.level === "WARN",
        );

      dispatch(
        setValidationState({
          errors: extractedErrors,
          warnings: extractedWarnings,
        }),
      );
    }
  }, [dispatch, lienValidation]);

  return (
    <div className="swim-wrapper h-100">
      {header && <div className="LienPageContainer__Header">{header}</div>}
      {children}
      {footer && <div className="LienPageContainer__Footer">{footer}</div>}
    </div>
  );
};

export default LienPageContainer;
